
  <div id="poster">
    <img v-if="$route.query.isSuccess === '1'" class="certificate" src="@/assets/img/sdws/pass-img.png" alt="">
    <img v-else class="certificate" src="@/assets/img/sdws/fail-img.png" alt="">
    <h1 class="title">
      <p>答题通关</p>
      <p>赢山东5A景区门票</p>
    </h1>
    <!-- <img class="avtor" :src="$store.getters.getUser?.avatar" alt="" > -->
    <img class="avtor" :src="$store.getters.getUser?.avatar" alt="">
    <h3 class="name">{{ $store.getters.getUser?.nickname || '匿名用户' }}</h3>
    <div class="success" v-if="$route.query.isSuccess === '1'">
      <template v-if="$route.query.isSuccess && $route.query.isSuccess === '0'">
        <p class="time-tips">最快用时{{ resInfo?.longTime }}</p>
        <p class="tips">我还没获得名次，你来试试？</p>
      </template>
      <template v-else>
        <p class="time-tips">
          最快用时{{ resInfo?.longTime }}, 暂排第{{  resInfo?.rowNum  }}名</p>
        <p class="tips">太轻松了，你来试试？</p>
      </template>
    </div>
    <template v-else>
      <p class="tips">题目很有挑战性，你来试试？</p>
    </template>
    <p class="rules" :class="{ 'rules-success': $route.query.isSuccess === '1' }">通关用时最短前500名赢山东省旅游通票</p>

    <div class="qrcode-wrap">
      <div class="text-wrap">
        <p class="text">看山东卫视，参与线上答题赢大奖！</p>
        <p class="tip-text">长按二维码参与活动</p>
      </div>
      <img class="qrcode" :src="qrcodeUrl" alt="">
    </div>
    <p class="company">山东广电信通网络运营有限公司技术支持</p>
  </div>
  <div class="img-wrap">
    <p class="share-tips">长按保存图片，分享好友</p>
  </div>
